import { cn } from '@/lib/utils';

export interface DescriptionItem {
  label: React.ReactNode;
  value: React.ReactNode;
  /** 그리드 열 병합(전체 폭). */
  span?: 'full';
}

interface DescriptionsProps {
  items: readonly DescriptionItem[];
  /** 열 수(sm 이상). 기본 2. */
  columns?: 1 | 2 | 3;
  className?: string;
}

/** 라벨·값 정의 목록 — ADescriptions 대체. 빈 값은 호출부가 orDash 로 정규화한다. */
export function Descriptions({ items, columns = 2, className }: DescriptionsProps) {
  const cols = { 1: 'sm:grid-cols-1', 2: 'sm:grid-cols-2', 3: 'sm:grid-cols-3' }[columns];
  return (
    <dl className={cn('grid grid-cols-1 gap-x-8 gap-y-4', cols, className)}>
      {items.map((it, i) => (
        <div
          key={i}
          className={cn(
            'flex flex-col gap-1 border-b pb-3',
            it.span === 'full' && 'sm:col-span-full',
          )}
        >
          <dt className="text-sm font-medium text-muted-foreground">{it.label}</dt>
          <dd className="m-0 text-sm">{it.value}</dd>
        </div>
      ))}
    </dl>
  );
}
